"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankstatementsCircleDataSublineTextTypeEnum = exports.BankstatementsCircleDataInnerTextTypeEnum = exports.BankstatementsCircleDataToJSON = exports.BankstatementsCircleDataFromJSONTyped = exports.BankstatementsCircleDataFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function BankstatementsCircleDataFromJSON(json) {
    return BankstatementsCircleDataFromJSONTyped(json, false);
}
exports.BankstatementsCircleDataFromJSON = BankstatementsCircleDataFromJSON;
function BankstatementsCircleDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': (0, _1.AmountFromJSON)(json['value']),
        'date': !(0, runtime_1.exists)(json, 'date') ? undefined : json['date'],
        'innerTextType': json['innerTextType'],
        'sublineTextType': json['sublineTextType'],
    };
}
exports.BankstatementsCircleDataFromJSONTyped = BankstatementsCircleDataFromJSONTyped;
function BankstatementsCircleDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': (0, _1.AmountToJSON)(value.value),
        'date': value.date,
        'innerTextType': value.innerTextType,
        'sublineTextType': value.sublineTextType,
    };
}
exports.BankstatementsCircleDataToJSON = BankstatementsCircleDataToJSON;
/**
* @export
* @enum {string}
*/
var BankstatementsCircleDataInnerTextTypeEnum;
(function (BankstatementsCircleDataInnerTextTypeEnum) {
    BankstatementsCircleDataInnerTextTypeEnum["ToPay"] = "toPay";
    BankstatementsCircleDataInnerTextTypeEnum["Withdraw"] = "withdraw";
})(BankstatementsCircleDataInnerTextTypeEnum = exports.BankstatementsCircleDataInnerTextTypeEnum || (exports.BankstatementsCircleDataInnerTextTypeEnum = {}));
/**
* @export
* @enum {string}
*/
var BankstatementsCircleDataSublineTextTypeEnum;
(function (BankstatementsCircleDataSublineTextTypeEnum) {
    BankstatementsCircleDataSublineTextTypeEnum["None"] = "none";
    BankstatementsCircleDataSublineTextTypeEnum["IncreasingPossible"] = "increasingPossible";
    BankstatementsCircleDataSublineTextTypeEnum["IncreasedDueToCustomersWish"] = "increasedDueToCustomersWish";
})(BankstatementsCircleDataSublineTextTypeEnum = exports.BankstatementsCircleDataSublineTextTypeEnum || (exports.BankstatementsCircleDataSublineTextTypeEnum = {}));
//# sourceMappingURL=BankstatementsCircleData.js.map